/**
 * Action creators for tethering (i.e. previewing questions from Question
 * Manager 2)
 */

export const REQUEST_START_TETHERING = 'REQUEST_START_TETHERING';
export const START_TETHERING = 'START_TETHERING';
export const STOP_TETHERING = 'STOP_TETHERING';
export const TETHER_QUESTION = 'TETHER_QUESTION';
export const TETHER_VIDEO = 'TETHER_VIDEO';
export const REQUEST_STOP_TETHERING = 'REQUEST_STOP_TETHERING';
export const REQUEST_GET_TETHERING_QUESTION = 'REQUEST_GET_TETHERING_QUESTION';
export const SET_CHECKING_MODE = 'SET_CHECKING_MODE';

/**
 * Action to request that app starts tethering with a given session name
 * @param sessionName the session name
 * @param saveSessionName if true, save the session name in local storage
 * for next time
 */
export function requestStartTethering(sessionName, saveSessionName) {
    return { type: REQUEST_START_TETHERING, sessionName, saveSessionName };
}

export function requestGetTetheringQuestion(lastTetherID = '', requestChangeNotification = true) {
    return { type: REQUEST_GET_TETHERING_QUESTION, lastTetherID, requestChangeNotification };
}

/**
 * Action to put the app into tethering mode once a device id has been retrieved
 * from the server
 */
export function startTethering(sessionName) {
    return { type: START_TETHERING, sessionName };
}

/**
 * Action to switch tethering to a particular question
 * @param question the question (an object)
 * @returns {{type: string, question: *}}
 */
export function tetherQuestion(question) {
    return { type: TETHER_QUESTION, question };
}

/**
 * Action to switch tethering to a particular video
 * @param video the video (an object)
 * @returns {{type: string, video: *}}
 */
export function tetherVideo(video) {
    return { type: TETHER_VIDEO, video };
}

/**
 * Action to request that tethering stops - this is initiated by the user
 * choosing to stop tethering
 * @returns {{type: *}}
 */
export function requestStopTethering() {
    return { type: REQUEST_STOP_TETHERING };
}

/**
 * Action to stop the current tethering session. This is fired after the user
 * requests that tethering stops (via a requestStopTethering action)
 */
export function stopTethering() {
    return { type: STOP_TETHERING };
}

/**
 * Action to set the tethering checking mode.
 */
export function setTetheringCheckingMode(checking) {
    return { type: SET_CHECKING_MODE, checking };
}
